import React, { useState, useCallback } from 'react';
import './styles/base.css';
import './styles/pages.css';
import './styles/form.css';
import FormularPage from './pages/FormularPage';
import DespreAmiabila from './pages/DespreAmiabila';
import ConditiiUtilizare from './pages/ConditiiUtilizare';

function App() {
  const [currentPage, setCurrentPage] = useState('form');
  const [menuOpen, setMenuOpen] = useState(false);

  const navigateTo = useCallback((page) => {
    setCurrentPage(page);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, []);

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  return (
    <div className="app-container">
      {/* HEADER */}
      <header className="main-header">
        <div className="header-container">
          <a href="https://autoklasen.ro" className="logo-link">
            <img 
              src="/logo-autoklasen.png" 
              alt="Autoklasen" 
              className="logo-img"
              onError={(e) => { 
                e.target.style.display = 'none'; 
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <span className="logo-fallback" style={{display: 'none'}}>AUTOKLASEN</span>
          </a>
          
          <button className="burger-btn" onClick={toggleMenu} aria-label="Meniu">
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
          </button>

          <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
            <button 
              className={`nav-link ${currentPage === 'form' ? 'active' : ''}`}
              onClick={() => navigateTo('form')}
            >
              Formular Amiabila
            </button>
            <button 
              className={`nav-link ${currentPage === 'despre' ? 'active' : ''}`}
              onClick={() => navigateTo('despre')}
            >
              Despre Constatarea Amiabila
            </button>
            <button 
              className={`nav-link ${currentPage === 'conditii' ? 'active' : ''}`}
              onClick={() => navigateTo('conditii')}
            >
              Conditii de utilizare
            </button>
          </nav>

          <a href="tel:0371719191" className="btn-call">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <span>0371 719 191</span>
          </a>
        </div>
      </header>

      {/* PAGE CONTENT */}
      {currentPage === 'form' && <FormularPage />}
      {currentPage === 'despre' && <DespreAmiabila navigateTo={navigateTo} />}
      {currentPage === 'conditii' && <ConditiiUtilizare />}

      {/* FOOTER */}
      <footer className="simple-footer">
        <p>© 2025 Autoklasen. Toate drepturile rezervate. | <a href="https://autoklasen.ro">autoklasen.ro</a></p>
      </footer>
    </div>
  );
}

export default App;